const { VITE_API_URL, VITE_ENV, VITE_SENTRY_DSN }: Record<string, string> = import.meta.env;

export { VITE_API_URL as API_URL };
export { VITE_ENV as ENV };
export { VITE_SENTRY_DSN as SENTRY_DSN };
